import { openBlock as a, createElementBlock as r, toDisplayString as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeTimePill",
  props: {
    /**
     * Date time display value
     */
    dateTimeDisplay: {
      type: String,
      required: !0
    },
    /**
     * Machine-readable attribute
     * Accepts a string value of YYYY-MM-DD or YYYY-MM-DDThh:mm:ssTZD
     */
    dateTime: {
      type: String,
      required: !0,
      validator: (t) => {
        const e = new Date(t);
        return e instanceof Date && !isNaN(e);
      }
    }
  }
}, s = ["dateTime"];
function m(t, e, i, p, l, d) {
  return a(), r("time", {
    "data-qa": "dt-recipe-time-pill",
    dateTime: i.dateTime,
    class: "d-recipe-time-pill"
  }, n(i.dateTimeDisplay), 9, s);
}
const u = /* @__PURE__ */ o(c, [["render", m]]);
export {
  u as default
};
//# sourceMappingURL=time-pill.js.map
